import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../../../services/translation/TranslationService";
import { Info } from "../../../../components/svg/svgImageList";
import Svg from "../../../../components/svg/Svg";
import Tooltip from "../../../../components/tooltip/Tooltip";

export default observer(
  ({
    sewerObjectsCount,
    inspectionsCount,
    analysingInspectionsCount,
    videoAnalysisCount,
    videoSegmentationCount,
  }: {
    sewerObjectsCount: number;
    inspectionsCount: number;
    analysingInspectionsCount: number;
    videoAnalysisCount: number;
    videoSegmentationCount: number;
  }) => {
    const totalCalls = useMemo(
      () => videoAnalysisCount + videoSegmentationCount,
      [videoAnalysisCount, videoSegmentationCount]
    );

    const excludedInspectionsCount = useMemo(
      () => inspectionsCount - analysingInspectionsCount,
      [analysingInspectionsCount, inspectionsCount]
    );

    const showExcludedInspections = useMemo(() => inspectionsCount !== 0, [inspectionsCount]);

    return (
      <>
        <label className="summary">
          {translationService.translate("damages.BatchProcessing.summary.selected-objects", {
            sewerObjectsCount: sewerObjectsCount,
          })}
        </label>
        <label className="summary">
          {translationService.translate("damages.BatchProcessing.summary.included-inspections", {
            inspectionsCount: inspectionsCount,
          })}
        </label>
        <label className="summary">
          {translationService.translate(
            "damages.BatchProcessing.summary.to-be-analyzed-inspections",
            {
              analysingInspectionsCount: analysingInspectionsCount,
            }
          )}
        </label>
        <label className="summary total">
          {translationService.translate("damages.BatchProcessing.summary.total-calls", {
            inspectionsCount: analysingInspectionsCount,
            callsCount: totalCalls,
          })}
        </label>
        <label className="total-breakdown">
          {translationService.translate("damages.BatchProcessing.summary.total-calls-breakdown", {
            analysisCallsCount: videoAnalysisCount,
            segmentationCallsCount: videoSegmentationCount,
          })}
        </label>
        {showExcludedInspections && (
          <label className="summary total-excluded">
            {translationService.translate("damages.BatchProcessing.summary.excluded-inspections", {
              excludedCount: excludedInspectionsCount,
            })}
            <Tooltip
              title={translationService.translate(
                "damages.BatchProcessing.summary.excluded-tooltip",
                { excludedCount: excludedInspectionsCount }
              )}
            >
              <Svg className="info" svg={Info} width={20} height={20} />
            </Tooltip>
          </label>
        )}
      </>
    );
  }
);
